module.exports = __webpack_public_path__ + "static/media/icon-golf.5b80b99a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-golf.svg
// module id = ./src/assets/images/icon-golf.svg
// module chunks = 6